import {
  GET_STICKY_COLUMNS,
  GET_STICKY_COLUMNS_SUCCESS,
  GET_STICKY_COLUMNS_ERROR,
  UPDATE_STICKY_COLUMNS,
  UPDATE_STICKY_COLUMNS_SUCCESS,
  UPDATE_STICKY_COLUMNS_ERROR
} from "./actionTypes"

// FOR GET ADMIN USER ROLE
export const getStickyColumns = () => {
  return {
    type: GET_STICKY_COLUMNS,
  }
}

export const getStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getStickyColumnsError = error => {
  return {
    type: GET_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

// FOR UPDATE ADMIN USER ROLE
export const updateStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateStickyColumnsError = error => {
  return {
    type: UPDATE_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}